import { makeOpenApiMethod } from "../make-openapi-method";

export const postTransaction = makeOpenApiMethod("/v4/transaction", "post", 201);

export const putTransaction = makeOpenApiMethod("/v4/transaction/redeem/{transactionId}", "put", 200);

export const updateTransaction = makeOpenApiMethod("/v4/transaction/{transactionId}/update", "post", 200);
